import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import { getMyAvailabilityConstants } from 'src/redux/actions/constant';
import myAvailabilityServices from 'src/services/apiServices/my-availability-services/my-availability-services';

const {
  EDIT_MY_AVAILABILITY_REQUEST,
  EDIT_MY_AVAILABILITY_SUCCESS,
  EDIT_MY_AVAILABILITY_FAILURE,
  EDIT_MY_AVAILABILITY_LOADING,
} = getMyAvailabilityConstants;

function* editMyAvailability(action: any): SagaReturnType<any> {
  try {
    yield put({ type: EDIT_MY_AVAILABILITY_LOADING });
    const response = yield call(myAvailabilityServices.editMyAvailability, action.payload);
    if (response?.status === 200) {
      yield put({ type: EDIT_MY_AVAILABILITY_SUCCESS, payload: response.data });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: EDIT_MY_AVAILABILITY_FAILURE, payload: error });
  }
}

function* editMyAvailabilitySaga() {
  yield takeEvery(EDIT_MY_AVAILABILITY_REQUEST, editMyAvailability);
}

export default editMyAvailabilitySaga;
